<td class="row-thumbnail align-middle rounded-start">
	<div>
		<img
			class="hover-opacity-50 p-0 rounded"
			[style.object-fit]="errorLoadingImage ? '' : 'fit'"
			[src]="
				(listing.mediaFileName
					| listingMediaUrl : 'thumb' : listing.modificationTimestampUTCDTTM : errorLoadingImage) ||
				'assets/images/svg/Img-Default-Camera.svg'
			"
			(error)="errorLoadingImage = true"
		/>
	</div>
</td>
<td class="align-middle">
	<div>
		<img
			class="pe-2 hover-brightness-2"
			style="height: 2em"
			[ngbTooltip]="listing.propertyTypeCD | translate"
			container="body"
			[src]="listing.propertyTypeCD | translate : { type: 'icon' }"
		/>
		<span>{{ listing.listingID }}</span>
	</div>
</td>
<td class="align-middle">
	<span
		><span class="badge bg-primary text-light" [ngbTooltip]="tooltipName$ | async"
			><i nstarIcon>agent</i> {{ displayName$ | async }}</span
		></span
	>
</td>
<td class="align-middle">
	<span
		[ngbTooltip]="
			hasContingency ? (listing.contingencyTypeCD | translate : { type: 'contingency' }) : null
		"
		container="body"
	>
		{{ listing.listingStatusName + (hasContingency ? "*" : "") }}
	</span>
</td>
<td class="align-middle">
	<address class="m-0">
		<span *ngIf="!!listing.unparsedAddress">{{ listing.unparsedAddress }}</span>
		<br
			*ngIf="
				!!listing.unparsedAddress &&
				(!!listing.cityName || !!listing.stateOrProvinceCD || !!listing.postalCode)
			"
		/>
		<span
			*ngIf="
				!!(displayLocationName$ | async) || !!listing.stateOrProvinceCD || !!listing.postalCode
			"
		>
			<span
				*ngIf="displayLocationName$ | async as displayLocationName"
				[ngbTooltip]="tooltipLocationName$ | async"
				>{{ displayLocationName }},
			</span>
			{{ listing.stateOrProvinceCD }} {{ listing.postalCode }}
		</span>
	</address>
</td>
<td class="align-middle">
	{{ price | currency : "USD" : "symbol" : "0.0-2" }}
</td>
<td class="align-middle">
	{{ listing.listingContractDT | date : "shortDate" }}
</td>
<td class="align-middle">
	{{ listing.expirationDT | date : "shortDate" }}
</td>
<td ngbDropdown display="dynamic" placement="bottom-right" class="align-middle rounded-end">
	<div>
		<button
			ngbDropdownToggle
			(click)="preventDefault($event)"
			ngbTooltip="Actions"
			container="body"
			class="btn btn-sm btn-secondary bg-secondary dropdown-toggle action-btn"
			type="button"
			id="dropdownMenuButton"
			data-toggle="dropdown"
			aria-haspopup="true"
			aria-expanded="false"
		>
			<i nstarIcon>tools</i>
		</button>
		<div ngbDropdownMenu class="dropdown-menu bg-white" aria-labelledby="dropdownMenuButton">
			<a
				nstarButton
				ngbDropdownItem
				class="dropdown-item recover-btn"
				*ngIf="canRecover$ | async"
				(click)="recoverListing($event)"
				><i nstarIcon>recover</i> Recover</a
			>
			<a
				nstarButton
				ngbDropdownItem
				class="dropdown-item clone-btn"
				*ngIf="canClone$ | async"
				(click)="cloneListing($event)"
				><i nstarIcon>clone</i> Clone</a
			>
			<a
				nstarButton
				ngbDropdownItem
				class="dropdown-item copy-btn"
				*ngIf="canCopy$ | async"
				(click)="copyListing($event)"
				><i nstarIcon>copy</i> Copy</a
			>
			<a
				nstarButton
				ngbDropdownItem
				class="dropdown-item delete-btn"
				*ngIf="canDelete$ | async"
				(click)="deleteListing($event)"
				><i nstarIcon>delete</i> Delete</a
			>
			<a ngbDropdownItem *ngIf="showPreviewAd" class="dropdown-item" (click)="previewAd($event)">
				<span class="bullhorn-icon"></span>
				{{ listing?.adbuilderCampaign ? "Manage Campaign" : adbuilderButtonTitle }}</a
			>
		</div>
	</div>
</td>
